"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Spacer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Spacer = require("./Spacer.style");

var _spaceOverrider = require("./spaceOverrider");

var Spacer = function Spacer(_ref) {
  var space = _ref.space,
      children = _ref.children;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      spacing = _ref2.spacing;

  var placeholderSpacing = space || spacing.main;
  return children ? /*#__PURE__*/_react.default.createElement(_Spacer.SpacerStyle, null, _react.default.Children.map(children, function (child) {
    var componentSpacing = (0, _spaceOverrider.spaceOverrider)(child, placeholderSpacing); // to protect null values as children from adding an empty div

    return child ? /*#__PURE__*/_react.default.createElement(_Spacer.SpaceWrapper, {
      py: componentSpacing
    }, child) : null;
  })) : /*#__PURE__*/_react.default.createElement(_Spacer.VerticalSpacing, {
    spacing: placeholderSpacing
  });
};

exports.Spacer = Spacer;
Spacer.propTypes = {
  space: _propTypes.default.oneOfType([_propTypes.default.oneOf(['none', 'xsmall', 'small', 'medium', 'base', 'large', 'xlarge', 'xxlarge', 'xxxlarge', 'xxxxlarge']), _propTypes.default.array]),
  children: _propTypes.default.node
};
Spacer.defaultProps = {
  space: null,
  children: undefined
};
var _default = Spacer;
exports.default = _default;